import { render, staticRenderFns } from "./ShowPreds.vue?vue&type=template&id=3dff8b06&scoped=true&"
import script from "./ShowPreds.vue?vue&type=script&lang=js&"
export * from "./ShowPreds.vue?vue&type=script&lang=js&"
import style0 from "./ShowPreds.vue?vue&type=style&index=0&id=3dff8b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dff8b06",
  null
  
)

component.options.__file = "ShowPreds.vue"
export default component.exports